import {ESLMedia} from '@exadel/esl/modules/esl-media/core';
import {attr} from '@exadel/esl/modules/esl-utils/decorators';
import {parseNumber} from '@exadel/esl/modules/esl-utils/misc';

export class HPEMedia extends ESLMedia {
  static override readonly is = 'smart-media';

  // TODO: move to ESL level as a common media attribute
  @attr({name: 'play-in-viewport-ratio-play', parser: parseNumber, defaultValue: ESLMedia.prototype.RATIO_TO_PLAY})
  public override RATIO_TO_PLAY: number;
  @attr({name: 'play-in-viewport-ratio-stop', parser: parseNumber, defaultValue: ESLMedia.prototype.RATIO_TO_STOP})
  public override RATIO_TO_STOP: number;
}
